module.exports = __webpack_public_path__ + "img/serve3.f2b44543.png";